import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { convertObjectToSingleString } from '../../../../utils/helper';
import { placeholderPlugin } from '../Placeholder';
import pluginKey from './pluginKey';
export const uploadFile = file => {
  const reader = new FileReader();
  return new Promise((accept, fail) => {
    reader.onload = () => accept(reader.result);
    reader.onerror = () => fail(reader.error);
    reader.readAsDataURL(file);
  });
};
const findPlaceholder = (state, id) => {
  const decos = placeholderPlugin.getState(state);
  const found = decos.find(null, null, spec => spec.id === id);
  return found.length ? found[0].from : null;
};
const createImageNode = (view, pos, placeHolderId, url, thumbUrl, name, type) => {
  if (type === 'image/png' || type === 'image/jpeg') {
    const imgAttributes = {
      src: url,
      alt: name
    };
    if (url !== thumbUrl) imgAttributes['thumbUrl'] = thumbUrl;
    const imageNode = view.state.schema.nodes.image.create(imgAttributes);
    view.dispatch(view.state.tr.replaceWith(pos, pos, view.state.schema.nodes.image.create({
      src: url,
      thumbUrl,
      alt: name
    })).setMeta(placeholderPlugin, {
      remove: {
        id: placeHolderId
      }
    }));
    view.state.tr.replaceSelectionWith(imageNode);
  } else {
    const mediaNode = view.state.schema.nodes.media.create({
      type,
      name,
      url,
      thumbUrl
    });
    view.dispatch(view.state.tr.replaceWith(pos, pos, mediaNode).setMeta(placeholderPlugin, {
      remove: {
        id: placeHolderId
      }
    }));
    view.state.tr.replaceSelectionWith(mediaNode);
  }
};
const startImageUpload = (view, options, file) => {
  if (!options.onUpload && !options.allowUploadDataUrl) return;
  const id = {};
  const style = {
    border: '3px solid #f3f3f3',
    'border-radius': '50%',
    'border-top': '3px solid #3498db',
    display: 'inline-block',
    margin: '0 1.4em',
    width: '2.8em',
    height: '2.8em',
    animation: 'spin 2s linear infinite'
  };
  const stringifiedStyle = convertObjectToSingleString(style) + '@keyframes spin {0% {transform: rotate(0deg);}100% {transform: rotate(360deg);}}';
  const {
    tr
  } = view.state;
  if (!tr.selection.empty) tr.deleteSelection();
  if (options.inline) {
    tr.setMeta(placeholderPlugin, {
      add: {
        id,
        pos: tr.selection.from
      },
      className: 'tap-image-loader',
      style: stringifiedStyle
    });
    view.dispatch(tr);
  }
  uploadFile(file).then(dataUrl => {
    const pos = findPlaceholder(view.state, id);
    if (options.inline && pos == null) return;
    const fileName = file.name;
    if (options && options.onUpload) {
      options.onUpload([file], uploadResponse => {
        const {
          name,
          url,
          thumbUrl
        } = uploadResponse[0];
        if (options.inline) {
          createImageNode(view, pos, id, url, thumbUrl, name, file.type);
        } else {
          options.events.emit('addAttachment', {
            url,
            name
          });
        }
      });
    } else if (options.inline) {
      createImageNode(view, pos, id, dataUrl, null, fileName, file.type);
    } else {
      options.events.emit('addAttachment', {
        url: dataUrl,
        name: fileName
      });
    }
  }, () => {
    view.dispatch(tr.setMeta(placeholderPlugin, {
      remove: {
        id
      }
    }));
  });
};
export const imageUpload = (editorView, options, e) => {
  const {
    target
  } = e;
  if (editorView.state.selection.$from.parent.inlineContent && target.files.length) {
    startImageUpload(editorView, options, target.files[0]);
    target.value = '';
  }
  editorView.focus();
};
export const setIsThumbnail = useThumbnail => (state, dispatch) => {
  const {
    pos
  } = pluginKey.getState(state);
  if (pos === null) {
    return false;
  }
  const node = state.doc.nodeAt(pos);
  const tr = state.tr.setNodeMarkup(pos, null, _objectSpread(_objectSpread({}, node.attrs), {}, {
    useThumbnail
  }));
  dispatch(tr);
  return false;
};
export const setAlignment = alignment => (state, dispatch) => {
  const {
    pos
  } = pluginKey.getState(state);
  if (pos === null) {
    return false;
  }
  const node = state.doc.nodeAt(pos);
  const tr = state.tr.setNodeMarkup(pos, null, _objectSpread(_objectSpread({}, node.attrs), {}, {
    alignment
  }));
  dispatch(tr);
  return false;
};